<template lang="pug">
    .categpry-post
        component(:is="view")
</template>

<script>

// import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import ContentPage from '@/views/ContentPage'

export default {
    name: 'CategoryPost',
    components: {
        ContentPage,
    },
    computed: {
        ...mapGetters({
            view: 'currentPage/view',
        })
    },
    methods: {
        ...mapMutations({
            updateHeaderVisibility: 'updateHeaderVisibility',
        })
    },
    mounted() {
        this.updateHeaderVisibility(false)
    }
}

</script>

<style lang="sass" scoped></style>
